export default __webpack_public_path__ + "static/media/locate.81c0ab7e.svg";